module.exports = __webpack_public_path__ + "static/media/fuelForeground.9135a517.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/CommitView/Fuel/fuelForeground.svg
// module id = 939
// module chunks = 0